<template>
  <div class="m-pagination">
    <ul class="m-pagination__items">
      <li class="m-pagination__item">
        <span @click="goTo(currentPage - 1)" :class="'m-pagination__link-prev' + (currentPage === 1 ? ' m-pagination__link--disabled' : ' m-pagination__hover')">
          {{ $t('pagination-previous') }}
        </span>
      </li>

      <div v-for="page in pages" :key="page">
        <li class="m-pagination__item">
          <span v-if="page === '...'" class="m-pagination__label">{{ page }}</span>
          <span v-else-if="page === currentPage" class="m-pagination__link m-pagination__link--current">{{ page }}</span>
          <span v-else @click="goTo(page)" class="m-pagination__link m-pagination__hover">{{ page }}</span>
        </li>
      </div>

      <li class="m-pagination__item">
        <span @click="goTo(currentPage + 1)" :class="'m-pagination__link-next' + (currentPage === nbPages ? ' m-pagination__link--disabled' : ' m-pagination__hover')">
          {{ $t('pagination-next') }}
        </span>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Number,
      required: true
    },
    nbPages: {
      type: Number,
      required: true
    }
  },
  computed: {
    currentPage: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    pages: function() {
      const pages = [1]

      // Maximum of 3 pages between current page and first/last page, else we add "..." inbetween
      if (this.currentPage > 5) {
        pages.push('...')
        for (let i = this.currentPage - 3; i < this.currentPage; i++) {
          pages.push(i)
        }
      } else {
        for (let i = 2; i < this.currentPage; i++) {
          pages.push(i)
        }
      }

      const from = this.currentPage !== 1 ? this.currentPage : this.currentPage + 1
      if (this.nbPages - this.currentPage > 4) {
        for (let i = from; i <= this.currentPage + 3; i++) {
          pages.push(i)
        }
        pages.push('...')
        pages.push(this.nbPages)
      } else {
        for (let i = from; i <= this.nbPages; i++) {
          pages.push(i)
        }
      }

      return pages
    }
  },
  methods: {
    goTo: function(page) {
      if (page > 0 && page <= this.nbPages) {
        this.currentPage = page
      }
    }
  }
}
</script>

<style lang="scss">
.m-pagination {
  &__hover:hover {
    cursor: pointer;
  }
}
</style>
